  <!--Contract new project request-->
  <div [hidden]="!ShowNewApplications" style="margin-top: 18px;">
    <h6 style="margin-left: 15px;">New Projects</h6>
    <p style="margin-top: 9px; margin-left: 15px;">
      The following homeowners request that you upload documents on their behalf.
    </p>
  </div>

  <div [hidden]="!ShowNewApplications" style="margin: 18px 15px;">
    <div *ngIf="toggleDisplayCardList">
      <div fxLayout="row wrap" fxLayout.xs="column wrap" style="margin-top: 18px;">
        <div *ngFor="let application of data" fxFlex.gt-xs="50%" [fxFlex.gt-md]="cardLayout">
          <div style="margin-top: 10px; margin-right: 10px;">
            <mat-card [class.mat-elevation-z7]='true'>
              <!-- Card Title -->
              <mat-card-title style="font-size: 16px;">{{application.name}}</mat-card-title>
              <mat-card-subtitle>
                Project number: {{application.applicationNumber}} ({{programTypeDesc(application.programType)}})
              </mat-card-subtitle>
              <mat-divider></mat-divider>
              <!-- Card Body -->
              <div style="margin-top: 32px !important">
                <mat-card-content>
                  <div>
                    <span>
                      <span class="card-label">Program</span>
                      <span class="card-value">
                        {{application._Ebb_ProgramCycleId_Formatted}}
                        <span class="card-value-light">
                          (accepted {{getFormattedDate(application.acceptedDate)}})
                        </span>
                      </span>
                    </span>
                  </div>
                  <div style="margin-top: 9px;">
                    <span>
                      <span class="card-label">Status</span>
                      <div [ngSwitch]="application.stageCode">
                        <div *ngSwitchCase="700000000" class="card-value">
                          <span *ngIf="application.applicationStatusOptionSet !== 'Extension'">Pre-retrofit - </span>
                          <span *ngIf="application.applicationStatusOptionSet === 'Extension'">Extension -
                            {{application.extensionDate | date: 'M/d/yyyy'}}</span>
                          <span *ngIf="application.itemsRejectedRollup > 0 else showNewPreStageNoReject">
                            <span class="warn-text">
                              Action Required
                            </span>
                          </span>
                          <ng-template #showNewPreStageNoReject>
                            <span *ngIf='application.eventPreliminaryReview'>
                              <p *ngIf='application.programType === 700000002
                                    else showContractorNewProjectSubmitted'>
                                FEMA Review <span> - </span> <span [innerHTML]="femareviewmessage"
                                  style=" display: inline-block;color: #377491;"></span>
                              </p>
                              <ng-template #showContractorNewProjectSubmitted>
                                Submitted
                              </ng-template>
                            </span>
                            <span *ngIf='!application.eventPreliminaryReview'>
                              <span class="warn-text">
                                Upload Documents
                              </span>
                            </span>
                          </ng-template>
                        </div>

                        <div *ngSwitchCase="700000001" class="card-value">
                          Post-retrofit -
                          <span *ngIf="application.itemsRejectedRollup > 0 else showNewPreStageNoReject">
                            <span class="warn-text">
                              Action Required
                            </span>
                          </span>
                          <ng-template #showNewPostStageNoReject>
                            <span class="accent-text">
                              Proceed with Project
                            </span>
                          </ng-template>
                        </div>
                        <div *ngSwitchCase="700000002" class="card-value">
                          Application In Review
                        </div>
                        <div *ngSwitchCase="700000003" class="card-value">
                          Application In Review
                        </div>
                      </div>
                    </span>
                  </div>
                  <div style="margin-top: 9px;">
                    <span>
                      <span class="card-label">Homeowner</span>
                      <span class="card-value">
                        {{application._Ebb_OwnerId_Formatted}}
                      </span>
                    </span>
                  </div>
                  <div *ngIf="isContractor() && application.contractorInvitationCode === 700000001" style="margin-top: 12px;">
                    <span class="card-label">
                      <span style="color: #2e7045; font-weight: 900;">NEW</span>
                    </span>
                    <span class="card-value">
                      Request to upload documents on {{getFormattedDate(application.contractorInvitationDate)}}
                    </span>
                  </div>
                </mat-card-content>
              </div>
              <mat-divider></mat-divider>
              <!-- Card Actions -->
              <mat-card-actions>
                <button mat-stroked-button color="accent" (click)="onClickContractorProxy(true, application.id)">
                  ACCEPT REQUEST
                </button>
                <button mat-stroked-button color="warn" ngStyle.gt-sm="{'margin-left': '9px'}" ngStyle.lt-md="{'margin-left': '3px'}"
                  (click)="onClickContractorProxy(false, application.id)">
                  REJECT REQUEST
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <div class="mat-elevation-z7" style="width: 100%" [hidden]="toggleDisplayCardList">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="_Ebb_OwnerId_Formatted" matSortDirection="asc" style="width: 100%">
        <ng-container matColumnDef="applicationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Application Number </th>
          <td mat-cell width="7%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item.applicationNumber}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="_Ebb_OwnerId_Formatted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner Name </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item._Ebb_OwnerId_Formatted}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
          <td mat-cell width="25%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{item.name}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acceptedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Accepted date </th>
          <td mat-cell width="7%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              {{getFormattedDate(item.acceptedDate)}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayretrofitdue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Phase Due Date </th>
          <td mat-cell width="8%;" *matCellDef="let item">

              <span style="font-size: 14px;">

                {{item.displayretrofitdue}}
              </span>



          </td>
        </ng-container>

        <ng-container matColumnDef="_Ebb_ProgramCycleId_Formatted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Program </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="item">
                {{item._Ebb_ProgramCycleId_Formatted | Filename}}
              </div>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="_EBB_ProgramType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
          <td mat-cell width="10%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="item">
                {{programTypeDesc(item.programType)}}
              </div>
            </span>
          </td>
        </ng-container>


        <ng-container matColumnDef="displaystatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell width="15%;" *matCellDef="let item">
            <span style="font-size: 14px;">
              <div *ngIf="isContractor() && item.stateCode === 0 ">
                <div [ngSwitch]="item.stageCode">
                  <div *ngSwitchCase="700000000" class="card-value">
                     {{item.displaystatus}}  <span *ngIf="item.applicationStatusOptionSet === 'Extension'">{{item.extensionDate | date: 'M/d/yyyy'}}</span><br />
                    <span *ngIf="item.itemsRejectedRollup > 0 else showActiveListPreStageNoReject">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                    <ng-template #showActiveListPreStageNoReject>
                      <span *ngIf='item.eventPreliminaryReview'>
                        <span *ngIf="item.programType !== 700000002">
                          Submitted
                        </span>
                        <span *ngIf="item.programType === 700000002">
                          FEMA Review  <br/> <span [innerHTML]="femareviewmessage" style=" display: inline-block;color: #377491;"></span>
                        </span>
                      </span>
                      <span *ngIf='!item.eventPreliminaryReview'>
                        <span *ngIf='isContractor() && !isHomeowner()' class="warn-text">
                          Upload Documents
                        </span>
                        <span *ngIf='isHomeowner()'>
                          <span *ngIf="item.applicationStatusOptionSet !== 'Extension'">In process</span>

                        </span>
                      </span>
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="700000001" class="card-value">
                    {{item.displaystatus}} <br />
                    <span *ngIf="item.itemsRejectedRollup > 0 else showActiveListPostStageNoReject">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                    <ng-template #showActiveListPostStageNoReject>
                      <span *ngIf='item.eventApplicationSubmitted'>
                        Submitted
                      </span>
                      <span *ngIf='!item.eventApplicationSubmitted'>
                        <span class="accent-text">
                          Proceed with Project
                        </span>
                      </span>
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="700000002" class="card-value">
                    {{item.displaystatus}} <br />
                    <span *ngIf="item.itemsRejectedRollup">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                  </div>
                  <div *ngSwitchCase="700000003" class="card-value">
                  {{item.displaystatus}} <br />
                    <span *ngIf="item.itemsRejectedRollup">
                      <span class="warn-text">
                        Action Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="isContractor() && item.stateCode === 1">
                <div [ngSwitch]="item.statusCode">
                  <div *ngSwitchCase="700000000" class="card-value">
                    <span style="color: #2a7f48;">
                      {{item.displaystatus}}
                    </span>
                  </div>
                  <div *ngSwitchCase="700000001" class="card-value">
                    <span style="color: #2a7f48;">
                      {{item.displaystatus}}
                    </span>
                  </div>

                </div>
              </div>
              <div *ngIf="!isInspector()">
                <ng-template #showStatusForInspector>
                  {{item.displaystatus}}
                </ng-template>
              </div>

            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell width="18%;" *matCellDef="let item">
            <div fxLayout="row wrap" fxLayoutGap="3px">
              <button mat-stroked-button color="accent" (click)="onClickContractorProxy(true, item.id)">
                ACCEPT
              </button>
              <button mat-stroked-button color="warn" (click)="onClickContractorProxy(false, item.id)">
                REJECT
              </button>
            </div>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator #dataPaginatorNew="matPaginator" [length]="dataSourceLength" [pageSizeOptions]="tablePageSizeOptions">
      </mat-paginator>
    </div>

  </div>

  <div [hidden]="!ShowNewApplications" style="height: 18px;">
  </div>
